const getters = {
    itemuom: (state) => state.itemuom,
    itemuomId: (state) => state.itemuomId,
    loading: state => state.loading
};

export default getters;
